import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import DownLoadimg from '@/components/downloadImg'
import Biyezehng from '@/components/biyezheng'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/download',
      name: 'download',
      component: DownLoadimg
    },
    {
      path: '/biyezheng',
      name: 'biyezheng',
      component: Biyezehng
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js